import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useState, useEffect } from "react";
import { Avatar, TabStrip, TabStripTab } from "@progress/kendo-react-layout";
import MattersDetailsPage from "./MattersDetailsPage";
import CaseActivitiesPage from "../CaseFile/CaseActivities/CaseActivitiesPage";
import MatterLedgerCardPage from "./MattersLedgerCardPage";
import MatterForm from "./MatterForm";
import { getMattersAllInfo } from "actions/matters.action";
import { PageTabItemTitle } from "components/tabs/TabItem/PageTabItemTitle";
import CaseWorkFlows from "../CaseFile/CaseWorkFlow/CaseWorkFlow";
import { useNavigate } from "react-router";
import MattersCreditsandDefaults from "./MattersCreditsDefaults";
import { DocRegisterListTile } from "components/DocumentRegister/DocRegisterListTile";
import { NotesListTile } from "components/Notes/NotesListTile";
import MattersCompletionPage from "./MatterCompletionPage";
import { RiskAssessment } from "components/RiskAssessments";
import { useAllowedLiscence } from "hooks/useAllowedLiscence";
import UndertakingsList from "components/Undertakings/UndertakingsList";
import { useCompany } from "services/companyService";
import AdditionalClientsTab from "./AdditionalClientsTab";

/*const options = ["Details", "Activities", "Tasks", "Ledger Card", "Work Flows"];*/
const BASE_OPTIONS = [
  "Details",
  "Credits & Defaults",
  "Completion",
  "Wills & Deeds",
  "Notes",
  "Risk Assessment",
  "Undertakings",
];

const MatterView = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showForm, setShowForm] = useState(false);
  const { subDataCheck } = useAllowedLiscence();
  const matterDetails = useSelector((state) => state.mattersList);
  const [currentMatterDetails, setcurrentMatterDetails] = useState();
  const [actiVeItem, setActiveItem] = useState(0);
  const { data: company } = useCompany();
  const hasMultipleClientsModule = Boolean(company?.modules?.MultipleClients);
  const options = React.useMemo(() => {
    if (!hasMultipleClientsModule) return BASE_OPTIONS;
    const idx = BASE_OPTIONS.indexOf("Completion");
    const inserted = [...BASE_OPTIONS];
    inserted.splice(idx + 1, 0, "Additional Clients");
    return inserted;
  }, [hasMultipleClientsModule]);
  const leadClient = currentMatterDetails?.client || {};
  const openCaseFile = () => {
    navigate(`/casefiles/${currentMatterDetails?.matterId}`);
  };

  useEffect(() => {
    if (matterDetails !== null) {
      setcurrentMatterDetails(
        matterDetails?.matterViewDetails[props.reference]?.data
      );
    }
  }, [matterDetails]);

  useEffect(() => {
    if (!showForm && currentMatterDetails?.matterId) {
      dispatch(getMattersAllInfo(currentMatterDetails?.matterId));
    }
  }, [showForm]);

  return (
    <div className="pt-3 px-2">
      <div className="row">
        <div className={`styles["view-tittle"] col`}>
          <TabStrip
            onSelect={(e) => setActiveItem(e.selected)}
            keepTabsMounted={true}
            selected={actiVeItem}
            // style={{ marginTop: "10px" }}
            className="pagetab mt-3 px-4 h-100"
            animation={false}
          >
            {options.map((item) => {
              return (
                <TabStripTab
                  title={
                    <PageTabItemTitle
                      index={options.indexOf(item)}
                      title={item}
                      selected={actiVeItem}
                    />
                  }
                  key={item}
                >
                  <div style={{ width: "100%" }}>
                    {item === "Details" && (
                      <MattersDetailsPage reference={props.reference} />
                    )}
                    {item === "Credits & Defaults" && (
                      <MattersCreditsandDefaults reference={props.reference} />
                    )}
                    {item === "Completion" && (
                      <MattersCompletionPage reference={props.reference} />
                    )}
                    {item === "Additional Clients" && (
                      <AdditionalClientsTab
                        formType="VIEW"
                        leadClient={{
                          clientId:
                            leadClient.clientId ??
                            currentMatterDetails?.clientId ??
                            null,
                          email: leadClient.email,
                          phone: leadClient.phoneNo,
                          address: leadClient.address,
                        }}
                        additionalClients={
                          currentMatterDetails?.additionalClients || []
                        }
                      />
                    )}
                    {item === "Wills & Deeds" && (
                      <DocRegisterListTile matterId={currentMatterDetails} />
                    )}

                    {item === "Notes" && (
                      <NotesListTile
                        matterId={currentMatterDetails?.matterId}
                      />
                    )}

                    {item === "Risk Assessment" && (
                      <RiskAssessment
                        matterId={currentMatterDetails?.matterId}
                      />
                    )}

                    {item === "Activities" && (
                      <CaseActivitiesPage
                        addFormText={
                          currentMatterDetails?.matterRef +
                          "-" +
                          currentMatterDetails?.details
                        }
                        reference={currentMatterDetails?.matterId}
                        matterDetails={currentMatterDetails}
                      />
                    )}
                    {item === "Ledger Card" && (
                      <MatterLedgerCardPage
                        selTab={props.selTab}
                        reference={currentMatterDetails?.matterId}
                      />
                    )}
                    {item === "Work Flows" && (
                      <CaseWorkFlows
                        selTab={props.selTab}
                        reference={currentMatterDetails}
                      />
                    )}

                    {item === "Undertakings" && (
                      <UndertakingsList
                        matterId={currentMatterDetails?.matterId}
                        clientId={currentMatterDetails?.clientId}
                        isView={true}
                      />
                    )}
                  </div>
                </TabStripTab>
              );
            })}
          </TabStrip>
        </div>
      </div>

      {showForm && (
        <MatterForm
          reference={props.reference}
          isView={true}
          setshowMatterForm={() => setShowForm(false)}
        />
      )}
    </div>
  );
};

export default MatterView;
